module.exports = __webpack_public_path__ + "img/loading.c0257cc3.svg";